import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const businesses = [
  {
    id: 'baby',
    tag: '事業 01',
    title: 'ベビー服事業',
    subtitle: '最初で最後の、大切なお洋服',
    description: '死産や未熟児など、小さな命との別れを経験されたご家族へ。ほんの短い時間でも、その子が生まれてきた証を大切に残してほしい。そんな想いから小さな赤ちゃんのためのお洋服を一つひとつ心を込めて作っています。',
    body: '悲しみの中にも、ぬくもりを感じられるように。Hugはご家族の想いに寄り添います。',
    items: [
      '死産した赤ちゃんのためのベビー服販売',
      '未熟児サイズのベビー服の販売',
      '赤ちゃんの体に合ったサイズの提供',
      '病院へのパンフレット設置',
      '注文後即日発送のスピード対応',
    ],
    image:
      'https://public.readdy.ai/ai/img_res/add08ac1686f54fb352d4befcc18894f.jpg',
    accent: '#C97B7B',
    tagBg: '#F7EDED',
    tagColor: '#C97B7B',
    border: '#E8C4C4',
  },
];

export default function BusinessSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: card1Ref, isVisible: card1Visible } = useScrollAnimation(0.1);

  return (
    <section id="business" className="py-28 px-6 bg-[#FEFCFA]">
      <div className="max-w-5xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-20 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#6B8F5E] text-xs tracking-[0.4em] mb-4 uppercase">Business</p>
          <h2 className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            事業内容
          </h2>
          <div className="w-12 h-px bg-[#C8B99A] mx-auto" />
        </div>

        <div className="flex flex-col gap-16">
          {businesses.map((biz) => (
            <div
              key={biz.id}
              ref={card1Ref}
              className={`flex flex-col md:flex-row gap-8 items-center fade-in-left ${card1Visible ? 'visible' : ''}`}
            >
              <div className="w-full md:w-1/2">
                <div
                  className="rounded-lg overflow-hidden"
                  style={{ width: '100%', height: '320px' }}
                >
                  <img
                    src={biz.image}
                    alt={biz.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="w-full md:w-1/2">
                <span
                  className="inline-block text-xs tracking-[0.3em] px-3 py-1 rounded-full mb-4"
                  style={{ backgroundColor: biz.tagBg, color: biz.tagColor }}
                >
                  {biz.tag}
                </span>
                <h3
                  className="text-2xl md:text-3xl font-light mb-3"
                  style={{ color: '#3A2E28', fontFamily: 'Noto Serif JP, serif' }}
                >
                  {biz.title}
                </h3>
                <p
                  className="text-sm mb-5 font-medium"
                  style={{ color: biz.accent }}
                >
                  {biz.subtitle}
                </p>
                <p className="text-[#6B5E57] text-sm leading-loose mb-3">
                  {biz.description}
                </p>
                <p className="text-[#3A2E28] text-sm leading-loose mb-6 font-medium" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  {biz.body}
                </p>

                <div
                  className="rounded-lg p-5"
                  style={{ backgroundColor: biz.tagBg, borderLeft: `3px solid ${biz.border}` }}
                >
                  <p className="text-xs tracking-widest mb-3" style={{ color: biz.accent }}>
                    主な取り組み
                  </p>
                  <ul className="flex flex-col gap-2">
                    {biz.items.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-[#6B5E57]">
                        <i className="ri-checkbox-circle-line mt-0.5" style={{ color: biz.accent }} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
